import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./ScrollToTop";
import Homepage from "./Components/Homepage";
import Footer from "./Components/Home/Footer/footer";
import Values from "./Components/Values/Values";
import Navbar from "./Components/Home/Navbar/navbar";
import Services from "./Components/Services/Services";
import Portfolio from "./Components/Portfolio/Portfolio";
import Events from "./Components/Events/Events";
import Careers from "./Components/Career/Careers";
import ContactPage from "./Components/Contact/Contact";
import TeamMembers from "./Components/Members/TeamMembers";
import JobDetailsPage from "./Components/JobDetails/JobDetails";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/aboutpage" element={<Values />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/events" element={<Events />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contactpage" element={<ContactPage />} />
          <Route path="/members" element={<TeamMembers />} />
          <Route path="careers/job/:jobId" exact element={<JobDetailsPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
